// extracted by mini-css-extract-plugin
export default {"page":"Blogs_page__+6-l4","wrap":"Blogs_wrap__lOy7i","head":"Blogs_head__jCMPp","eyebrow":"Blogs_eyebrow__Mg82s"};